import { HeartIcon } from '@synergy/theme-next';
import { styled } from '@mui/material';

interface FavoriteHeartIconProps {
    isFavorite?: boolean;
}

export const FavoriteHeartIcon = styled(HeartIcon, {
    shouldForwardProp: prop => prop !== 'isFavorite',
})<FavoriteHeartIconProps>(({ theme, isFavorite, color }) => ({
    color: color || theme.palette.medium.main,
    ...(isFavorite && {
        path: {
            stroke: theme.palette.primary.main,
            fill: theme.palette.primary.main,
        },
    }),
}));
